import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../atoms/svg-icon';
import {
  getSourceDisplayName,
  getSyndicatedSource,
  hasSection,
} from '../../../helpers/story-helpers';
import './opinion-badge.module.css';

const OpinionBadge = ({ story }) => {
  let publisher = null;
  let slug = null;
  const showBloombergOpinion =
    hasSection(story.sections, 'View') || hasSection(story.sections, 'Gadfly');
  const showOtherSourcesOpinion = hasSection(story.sections, 'Opinion');

  if (showBloombergOpinion) {
    slug = showBloombergOpinion.slug;
    publisher = 'Bloomberg';
  } else if (showOtherSourcesOpinion) {
    slug = showOtherSourcesOpinion.slug;
    publisher = getSourceDisplayName(getSyndicatedSource(story));
  }
  const svgType = publisher === 'Bloomberg' ? 'bloomberg-opinion1' : 'bq-opinion';

  return (
    <a href={`/${slug}`} styleName="opinion-category">
      {/* <span styleName="syndicated">{getSourceDisplayName(syndicatedSource)}</span>
        <span styleName="opinion">Opinion</span> */}
      <SvgIcon
        type={svgType}
        width={publisher === 'Bloomberg' ? '140' : '200'}
        height="29"
        viewBox="0 0 210 30"
        iconStyle={{ fill: '#b7bfc4' }}
      />
    </a>
  );
};

OpinionBadge.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default OpinionBadge;
